import assertString from "./utils/assertString";
import regexList from "./utils/regexList";
import regexTest from "./utils/regexTest";


export default function isNepaliAlphabet(str, responseText) {
    const regVal = regexList.nepName.pattern;
    return regexTest(str, regVal, responseText) || regexList.nepName.response;
}